import CarrierAccountDetailsModal from 'app/views/modals/carrier_account_details_modal';
import DeleteCarrierAccountModal from 'app/views/modals/delete_carrier_account_modal';

import Base from 'app/views/base';
import tmpl from 'templates/carrier_account_list_item';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click a.edit': 'showDetailsModal',
    'click a.delete': 'showDeleteModal',
  },

  initialize() {
    this.detailsModal = new CarrierAccountDetailsModal({ model: this.model });

    this.deleteModal = new DeleteCarrierAccountModal({
      model: this.model,
      collection: this.collection,
    });

    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    return {
      id: this.model.id,
      reference: this.model.get('reference'),
      readable: this.model.get('readable'),
      type: this.model.get('type'),
      description: this.model.get('description'),
    };
  },

  showDetailsModal(event) {
    event.preventDefault();
    this.detailsModal.show();
  },

  showDeleteModal(event) {
    event.preventDefault();
    this.deleteModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/views/carrier_account_list_item_view.js